import React from 'react';
import { graphql, useFragment } from 'react-relay';
import { UserProfile } from '@atlassian/jira-directory-base-v3/src/ui/common/user-profile/UserProfile.tsx';
import type { LeadCell$key } from '@atlassian/jira-relay/src/__generated__/LeadCell.graphql';

type Props = {
	project: LeadCell$key;
};

export const LeadCell = ({ project }: Props): React.JSX.Element | null => {
	const data = useFragment(
		graphql`
			fragment LeadCell on JiraProject {
				lead @optIn(to: "JiraLead") {
					...UserProfile
				}
			}
		`,
		project,
	);

	return data?.lead ? <UserProfile dataRef={data.lead} /> : null;
};
